import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import OrderSummary from "../confirmation/confirmation-components/OrderSummary";
import OrderRenewalSummary from "../confirmation/confirmation-components/OrderRenewalSummary";
import SchoolDetails from "./order-form-components/SchoolDetails";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import AdditionalUserMessage from "../basket/basket-components/AdditionalUserMessage";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import PrintedTestsWarning from "../catalog/catalog-components/package-item-components/testbase-components/PrintedTestsWarning";

const OrderForm = (props) => {
	const [show, setShow] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (props.basket.length === 0 && props.renewal === false) {
			setShow(true);
		}
	}, []);

	return (
		<div style={{ padding: 20 }}>
			<div justify="center" spacing={40}>
				<Container fluid>
					<Row className="school-details-form__row">
						<Col xs={12} lg={6} className="school-details-form__col">
							<SchoolDetails
								submitOrder={props.submitOrder}
								formValues={props.formValues}
								updateMainState={props.updateMainState}
								MD5={props.MD5}
								resetBasket={props.resetBasket}
								brandName={props.brandName}
								basket={props.basket}
								setPromo_code={props.setPromo_code}
								brand={props.brand}
								subtotal={props.orderSubtotal}
								renewal={props.renewal}
								paperPackage={props.paperPackage}
							/>
						</Col>
						<Col xs={12} lg={6}>
							<div className="fixed-summary">
								{props.renewal && props.brand == "EP" ? (
									<OrderRenewalSummary
										basket={props.basket}
										renewal={props.renewal}
										handleShowBasket={props.handleShowBasket}
										paperPackage={props.paperPackage}
									/>
								) : (
									<OrderSummary
										basket={props.basket}
										renewal={props.renewal}
										paperPackage={props.paperPackage}
									/>
								)}
								<div className="order-button-container">
									<Button
										onClick={props.handleShowBasket}
										className={props.renewal ? "complete-order-renew-btn" : "complete-order-btn"}
									>
										<i className="fa fa-edit order-add-btn"></i>
										Edit in basket
									</Button>
									{props.freePackage ? (
										""
									) : (
										<Button
											className={props.renewal ? "complete-order-renew-btn" : "complete-order-btn"}
											onClick={() => {
												navigate(`/?brand=${props.brand}`);
											}}
										>
											<i className="fa fa-plus order-add-btn"></i>
											Add more subjects
										</Button>
									)}
								</div>
								<AdditionalUserMessage
									brand={props.brand}
									packages={props.basket}
									handleShowBasket={props.handleShowBasket}
									renewal={props.renewal}
									paperPackage={props.paperPackage}
								/>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
			<Modal show={show} backdrop="static" keyboard={false}>
				<Modal.Header>
					<Modal.Title>Your Basket is Empty</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					It seems your basket is empty. To complete your order{" "}
					<Link to={`/?brand=${props.brand}`}>
						follow this link to add some packages to your basket.
					</Link>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default OrderForm;
